import * as React from "react";
import BannerSwoosh from "../../assets/banner-swoosh.svg";
import { func } from "../../../../../utils";

export interface Props {
  data: {
    city: string;
    date: string;
    iconUrl: string;
    eventPlace: string;
  };
}

const BannerFormRegistration: React.FC<Props> = ({ data }) => {
  const getValueSafely = (value: number | string) => {
    if (typeof value === "number") return value ?? 0;

    return value ?? "-";
  };

  return (
    <div
      className="h-[90px] w-[100vw] max-w-[600px] bg-no-repeat py-[12px] px-[24px] border-b-[2px] border-b-[#F0F2F9]"
      style={{
        background: `url(${BannerSwoosh})`,
        backgroundSize: "100% 90px",
      }}
    >
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-y-[6px]">
          <h1 className="text-[18px] leading-none line- font-bold">
            {getValueSafely(data?.city)}
          </h1>
          <p className="text-[13px] leading-none text-[#6A7481] font-semibold">
            {getValueSafely(data?.date)}
          </p>
          <p className="flex gap-x-[4px] items-center leading-none text-[12px] text-[#6A7481] pt-[3px]">
            <img
              className="relative top-[-2px]"
              src={func.getStaticImg(`/illustration/pin location.svg`)}
            />
            {getValueSafely(data?.eventPlace)}
          </p>
        </div>
        <img
          style={{ objectFit: "cover", width: 64, height: 52 }}
          src={func.getStaticImg("illustration/piala-byU-2025-d.png")}
          alt="Banner Registration Icon"
        />
      </div>
    </div>
  );
};

export default BannerFormRegistration;
